import React from 'react';
import './Logo.css';

interface LogoProps {
  className?: string;
}

const Logo: React.FC<LogoProps> = ({ className = '' }) => {
  return (
    <a href="/" className={`logo ${className}`}>
      <span>D</span>
      <span>a</span>
      <span>t</span>
      <span>a</span>
      <span>N</span>
      <span>a</span>
      <span>a</span>
      <span>n</span>
      <span className="logo-beta">BETA</span>
    </a>
  );
};

export default Logo;
